module.exports = __webpack_public_path__ + "img/Documents.61a67b4d.svg";